import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import MaterialSelector from '../MaterialSelector';
import TransomConfigurator from './../TransomConfigurator';
import RadioGroup from './../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view01ImageOptions } from './views/exterior_view01'

class XC38Sprayhood extends Component {
    constructor(props) {
        super(props);
        this.handleSprayhoodChange = this.handleSprayhoodChange.bind(this);
        this.handleBoomCoverChange = this.handleBoomCoverChange.bind(this);
        this.handleSprayhoodTypeChange = this.handleSprayhoodTypeChange.bind(this);
    }
    
    handleSprayhoodChange(newValue) {
        let configuration = this.props.configuration;
        configuration.SprayHood = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleBoomCoverChange(newValue) {
        let configuration = this.props.configuration;
        configuration.BoomCover = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleSprayhoodTypeChange(newValue) {
        let configuration = this.props.configuration;
        configuration.SprayHoodType = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = exterior_view01ImageOptions;

        let image = (
            <TransomConfigurator name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 1800, height: 785 }} transform={
                [
                    0.056576, -0.011704, 0, -0.000061,
                    0.011961, 0.097409, 0, 0.000008,
                    0, 0, 1, 0,
                    214, 320, 0, 1
                ]}>
                <ConfiguratorImage boat="XC38" configuration={this.props.configuration} options={imageOptions} />
            </TransomConfigurator>
        );

        return (
            <ConfiguratorSection image={image}>
                
                <ConfiguratorOption>

                    <h1><Trans defaults='Sprayhood &amp; Boom Cover' /></h1>

                    <p><Trans defaults='Excellent cockpit protection with various options.' /></p>
                    <p><Trans defaults='In this configurator, you can visualize the sprayhood options only.' /></p>
                    <p><Trans defaults='Apart from the options below, sprayhood and boom cover - there are also options for cockpit tent, bimini, cockpit cushions and forestay cover. These options are not included in the configurator. Please, contact your local dealer for more information.' /></p>

                    <h2><Trans defaults='Sprayhood' /></h2>
                    <MaterialSelector label={this.props.configuration.SprayHood.label} options={this.props.sprayhoodOptions} value={this.props.configuration.SprayHood} onChange={this.handleSprayhoodChange} />
                    <RadioGroup label={this.props.t("Version:")} options={this.props.sprayhoodTypeOptions} value={this.props.configuration.SprayHoodType} onChange={this.handleSprayhoodTypeChange} />
                    
                    <h2><Trans defaults='Boom Cover' /></h2>
                    <MaterialSelector label={this.props.configuration.BoomCover.label} options={this.props.boomCoverOptions} value={this.props.configuration.BoomCover} onChange={this.handleBoomCoverChange} />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XC38Sprayhood);


// WEBPACK FOOTER //
// ./src/XC38/XC38Sprayhood.js